import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-exam-counter',
    templateUrl: './pb-exam-counter.component.html',
    styleUrls: ['./pb-exam-counter.component.scss']
})
export class PbExamCounterComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';

    // Exam Passes and Courses

    coursePlaceholderText: string = 'Loading ...';
    selectedCourse: any = {};
    examsPassed: any = ['0', '0', '0', '0'];
    courses: any = [];
    year: any = '';

    constructor(private api: ApiService, private cd: ChangeDetectorRef, private zone: NgZone, private router: Router) { }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchCounters();
        this.fetchCourses();

    }

    /**
    * Fetches counter
    * Used for exams passed counter near the top of the homepage
    */
    async fetchCounters() {

        await this.api.fetch_counters()
            .subscribe(res => {
                this.year = res.data.items[0].year;
                let paddedNumber = this.pad(res.data.items[0].exams_passed, 4);
                this.examsPassed = Array.from(paddedNumber);
                this.cd.detectChanges();
            }, (err) => {
                this.examsPassed = ['0', '0', '0', '0'];
            });

    }

    /**
     * Click on 'Get Started' to navigate to selected course
     * If not course has been selected then navigate to course catalogue
     */
    getStarted() {

        if (this.selectedCourse && Object.keys(this.selectedCourse).length !== 0) {
            this.zone.run(() => {
                this.router.navigate([`/courses/${this.selectedCourse.slug}`]);
            });
        } else {
            this.zone.run(() => {
                this.router.navigateByUrl('/courses');
            });
        }

    }

    /**
    * Pads a number with '0' for a specified size
    * @param num
    * @param size
    * @returns
    */
    pad(num: number, size: number): string {

        let s = num + '';
        while (s.length < size) { s = '0' + s; }
        return s;

    }

    /**
     * Fetch all courses.
     * This data is then used in the dropdown next to the exams passed counter
     */
    async fetchCourses() {



        await this.api.fetch_institutions('?orderBy=short_title')
            .subscribe(res => {
                res.data.items.forEach(element => {
                    this.courses.push(element);
                });

                this.cd.detectChanges();
                this.coursePlaceholderText = "Select course";
            }, (err) => {
                this.coursePlaceholderText = "Unable to load courses. Please refresh.";
            });

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

}
